import 'css-chunk:src/app/containers/Home/OrganizationsView/OrganizationListView.scss';export default {
  "OrganizationListView": "_OrganizationListView_moa9t_2",
  "header": "_header_moa9t_2",
  "createButton": "_createButton_moa9t_7",
  "table": "_table_moa9t_10",
  "nameCell": "_nameCell_moa9t_10"
};